import { useCallback } from 'react';
import { usePathBuilder, useRealm } from 'ciam-self-service-shared';
import { useHistory } from 'react-router';
import AuthTreeError from '../../utils/authTree/AuthTreeError';
import { OnDemandOTPRedirectError, OnDemandOTPUnauthenticatedError } from './authTree/errors';
import { updateErrorCode } from 'components/Login/actions';
import { useDispatch } from 'react-redux';
import { mapErrorFromJson } from 'utils/error-map';
import { logoutHandler } from 'components/Logout/actions';

export default function useAuthTreeErrorHandler() {
  const history = useHistory();
  const pathBuilder = usePathBuilder();
  const dispatch = useDispatch();
  const realm = useRealm();
  return useCallback(
    (error) => {
      if (error instanceof OnDemandOTPRedirectError) {
        // Nothing as redirect will occur
      } else if (error instanceof OnDemandOTPUnauthenticatedError || error instanceof AuthTreeError) {
        if (error.code === 'D_622') {
          // this will check for max otp retry limit
          logoutHandler(realm)(dispatch);
          dispatch(updateErrorCode(mapErrorFromJson('D_622')));
          const path = pathBuilder('/signin', true, { searchParams: { goto: undefined }, showError: true });
          history.push(path);
        } else {
          const path = pathBuilder('/signin', true, { searchParams: { goto: undefined } });
          history.push(path);
        }
      } else {
        throw error;
      }
    },
    [dispatch, history, pathBuilder, realm],
  );
}
